var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"tooltip",staticClass:"tooltip offset_50"},[_c('info-icon',{staticClass:"icon",attrs:{"size":"12"}}),_c('div',{staticClass:"tooltip__content text-small"},[_vm._v(_vm._s(_vm.description))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }